import {
  LiquidLimitEquipmentDetailsSection,
  LiquidLimitMethodBTrialSection,
} from 'Components/Worksheets/AtterbergLimitWorksheet/Astm/Sections';
import {
  IWithWorksheetInjectedProps,
  WorksheetBalanceFieldSet,
  WorksheetEquipmentDropdown,
} from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Checkbox, Field, Label, TextOutput } from '../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { FieldSet, ListFieldSection, PageSection, SectionGroup } from '../../../../../Layout';
import AtterbergLimitChartSection from '../../../Shared/ChartSection';

let LiquidLimitMethodBPageSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const determinationPerformed = useSelector(
    pipe(createWorksheetSelector!('LiquidLimit.NonPlastic'), valueOrDefault(false), (np) => !np)
  );
  const testForOrganics = useSelector(
    pipe(createWorksheetSelector!('Preparation.TestForOrganics'), valueOrDefault(false))
  );

  return (
    <PageSection heading="Liquid Limit">
      <NamePrefixModifier appendNamePrefix="LiquidLimit">
        <LiquidLimitEquipmentDetailsSection />
        <SectionGroup heading="Liquid Limit Determination">
          <ListFieldSection>
            <FieldSet>
              <Label>Material Suitability</Label>
              <Field input={<Checkbox />} label="Result cannot be obtained" name="NonPlastic" />
            </FieldSet>
          </ListFieldSection>
          {determinationPerformed && (
            <>
              <ListFieldSection>
                <WorksheetBalanceFieldSet label="Balance" name="Balance" />
                <Field input={<WorksheetEquipmentDropdown />} label="Oven" equipmentType="oven" name="Oven" />
                <WorksheetBalanceFieldSet label="Dry Mass Balance" name="DryMassBalance" />
              </ListFieldSection>
              <LiquidLimitMethodBTrialSection />
            </>
          )}
        </SectionGroup>
      </NamePrefixModifier>
      <SectionGroup heading="Result">
        <NamePrefixModifier namePrefix="flowChart">
          <AtterbergLimitChartSection visible={determinationPerformed} />
        </NamePrefixModifier>
        <ListFieldSection>
          {determinationPerformed && (
            <Field input={<TextOutput />} label="Average Liquid Limit" name="Results.LiquidLimit" />
          )}
          <Field input={<TextOutput />} label="Liquid Limit" name="Results.LiquidLimitText" />
        </ListFieldSection>
      </SectionGroup>
      {testForOrganics ? (
        <>
          <NamePrefixModifier appendNamePrefix="LiquidLimitOvenDried">
            <SectionGroup heading="Oven Dry Liquid Limit Determination">
              {determinationPerformed && (
                <>
                  <ListFieldSection>
                    <WorksheetBalanceFieldSet label="Balance" name="Balance" />
                    <Field input={<WorksheetEquipmentDropdown />} label="Oven" equipmentType="oven" name="Oven" />
                    <WorksheetBalanceFieldSet label="Dry Mass Balance" name="DryMassBalance" />
                  </ListFieldSection>
                  <LiquidLimitMethodBTrialSection />
                </>
              )}
            </SectionGroup>
          </NamePrefixModifier>
          <SectionGroup heading="Result">
            <NamePrefixModifier namePrefix="flowChartOvenDry">
              <AtterbergLimitChartSection />
            </NamePrefixModifier>
            <ListFieldSection>
              {determinationPerformed && (
                <Field input={<TextOutput />} label="Average Liquid Limit" name="Results.LiquidLimitOvenDried" />
              )}
              <Field input={<TextOutput />} label="Liquid Limit (Oven Dry)" name="Results.LiquidLimitOvenDriedText" />
              <Field input={<TextOutput />} label="LL (Oven Dry) / LL" name="Results.LiquidLimitRatio" />
              <Field input={<TextOutput />} label="Organic Material" name="Results.ContainsOrganicMaterial" />
            </ListFieldSection>
          </SectionGroup>
        </>
      ) : null}
    </PageSection>
  );
};

LiquidLimitMethodBPageSection = withInjectedProps(LiquidLimitMethodBPageSection);

export { LiquidLimitMethodBPageSection };
export default LiquidLimitMethodBPageSection;
